export { default, loader, LoadingFallback } from "~/components/header/index"


export const eager = true;
export const sync = true;
